import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Paper,
    TableBody,
    Avatar,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format, set } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded, CalendarMonthRounded, ContentCopy, CopyAll, Download, DownloadDoneOutlined, DownloadOutlined, LocationOn } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import Statbox from "../Dashborad/Statbox";
import { ClockIcon } from "@mui/x-date-pickers";
import ApplicationDetailPopup from "../Utils/ApplicationDetailPopup";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const JobDetailScreen = () => {
    return <CommunityListView />;
};

function CommunityListView({ data }) {

    const query = useQuery()
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')
    const [metrics, setMetrics] = useState({})
    const [jobDetails, setJobDetails] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [hasEnded, setHasEnded] = useState(false)
    const [limit, setLimnit] = useState(30)
    const [totalApplicant, setTotalApplicant] = useState(0)
    const [registrations, setRegistrations] = useState([])
    const [additinalQuestions, setAdditionalQuestions] = useState([])
    const [selectedApplication, setSelectedApplication] = useState({})
    const navigate = useNavigate()

    useEffect(() => {
        getJobDetails()
        getJobRegistrations(1)
    }, []);


    const getJobDetails = async () => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/jobs/get-job-data-metrics/${query.get("job")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        console.log(data)
        if (data.success === true) {
            setJobDetails(data.response)
            setAdditionalQuestions(data.response.questions)
        } else {
            alert(data.response)
        }

    };

    const formatAmount = (amount) => {
        if (amount < 999999) {
            const k_amount = amount / 1000
            const formatted = k_amount.toFixed(0)
            return `${formatted}k`
        }

        if (amount > 999999 && amount < 9999999) {
            const l_amount = amount / 100000
            const formatted = l_amount.toFixed(1)
            return `${formatted}L`
        }

        if (amount > 9999999) {
            const cr_amount = amount / 10000000
            const formatted = cr_amount.toFixed(1)
            return `${formatted}cr`
        }
    }

    function getSalary(job) {

        const payRangeStart = job.payRangeStart
        const payRangeEnd = job.payRangeEnd

        if (payRangeStart == 0 && payRangeEnd == 0) {
            return "-"
        }

        if (payRangeEnd == 0) {
            return `${job.amountPrefix}${formatAmount(payRangeStart)}`
        }

        if (payRangeEnd != 0) {
            return `${job.amountPrefix}${formatAmount(payRangeStart)}-${job.amountPrefix}${formatAmount(payRangeEnd)}`
        }

    }

    const getJobRegistrations = async (page) => {
        if (page == 1) {
            setRegistrations([])
            setHasEnded(false)
        }
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/jobs/get-job-registrations/${query.get("job")}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setRegistrations(prev => page == 1 ? data.response : [...prev, ...data.response])
            if (page == 1) {
                setTotalApplicant(data.pagination?.total ?? 0)
            }
            setCurrentPage(page)
            if (data.response.length < limit) {
                setHasEnded(true)
            }
        } else {
            alert(data.response)
        }

    };


    function formatMongoTime(dateInput, format = "DD MMMM YYYY, hh:mm A") {
        const date = new Date(dateInput);

        const map = {
            DD: String(date.getDate()).padStart(2, "0"),
            MMMM: date.toLocaleString("en-US", { month: "long" }),   // FULL MONTH
            MMM: date.toLocaleString("en-US", { month: "short" }),
            MM: String(date.getMonth() + 1).padStart(2, "0"),
            YYYY: date.getFullYear(),
            YY: String(date.getFullYear()).slice(-2),
            hh: String((date.getHours() % 12) || 12).padStart(2, "0"),
            HH: String(date.getHours()).padStart(2, "0"),
            mm: String(date.getMinutes()).padStart(2, "0"),
            ss: String(date.getSeconds()).padStart(2, "0"),
            A: date.getHours() >= 12 ? "PM" : "AM"
        };

        return format.replace(/MMMM|MMM|DD|MM|YYYY|YY|hh|HH|mm|ss|A/g, m => map[m]);
    }

    const dpr = window.devicePixelRatio || 1;



    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'} alignSelf={"stretch"}>

                <Box
                    display={"flex"}
                    flexDirection={(isMobileScreen || isTabScreen) ? "column" : "row"}
                    alignSelf={"stretch"}
                    width={"100%"}
                    pb={"20px"}
                    sx={{

                    }}
                    gap={(isMobileScreen || isTabScreen) ? "20px" : "20px"}
                >
                    {/* ROW 1 */}
                    <Box

                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background: "#ffffff08",
                            flexDirection: "column",
                            padding: "20px",
                            position: "relative",
                            width: isMobileScreen ? "100%" : isTabScreen ? "90%" : "50%"
                        }}
                        display="flex"
                    >

                        <Box sx={{ flexDirection: (isMobileScreen || isTabScreen) ? "column" : "row", display: "flex", }} >

                            <Box sx={{
                                display: 'flex', alignItems: 'center', width: "100px",
                                flexDirection: "column", height: "100px", aspectRatio: 1 / 1, position: "relative"
                            }}>
                                <img
                                    alt="img"
                                    width={"100%"}
                                    height={"100%"}
                                    src={`${jobDetails.club ? jobDetails.club?.clubLogo ?? "" : jobDetails.creator?.image[0] ?? ""}`}
                                    style={{
                                        aspectRatio: 1 / 1,
                                        cursor: "pointer", objectFit: 'cover',
                                        borderRadius: "15px",
                                        background: "#ffffff05",
                                        border: "2px solid #ffffff05"
                                    }}
                                />

                            </Box>

                            <Box sx={{ flex: 1, display: "flex" }} />

                            <Box sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "5px"
                            }}>

                                {
                                    jobDetails.boost?.isBoosted && new Date(jobDetails.boost?.validity).getTime() > new Date().getTime() && (
                                        <Typography color={"#943bff"}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"14px"}
                                            style={{
                                                alignSelf: "flex-start",
                                                paddingBlock: "5px",
                                                paddingInline: "8px",
                                                background: "#943bff20",
                                                borderRadius: "10px",
                                                border: "1px solid #943bff30",
                                                marginTop: "10px"
                                            }}
                                        >{"🚀"}</Typography>
                                    )
                                }

                                {
                                    jobDetails.priorityPass?.enabled && new Date(jobDetails.priorityPass?.validity).getTime() > new Date().getTime() && (
                                        <Typography color={"#ff8800"}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"14px"}
                                            style={{
                                                alignSelf: "flex-start",
                                                paddingBlock: "5px",
                                                paddingInline: "12px",
                                                background: "#ff880010",
                                                border: "1px solid #ff880030",
                                                borderRadius: "10px",
                                                marginTop: "10px"
                                            }}
                                        >{"Priority Pass ✨"}</Typography>
                                    )
                                }

                            </Box>

                        </Box>
                        <Box sx={{ flexDirection: "column", display: "flex", marginTop: "10px" }} >
                            <Typography color={"#ffffff"}
                                fontFamily={"poppins-reg"}
                                fontSize={"22px"}
                                style={{
                                    display: "-webkit-box",
                                    WebkitLineClamp: 4,      // change to 3,4 if needed
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden"
                                }}
                            >{jobDetails.title ?? "Untitled Job"}</Typography>

                            <Typography color={"#aaaaaa"}
                                fontFamily={"poppins-reg"}
                                style={{
                                    marginTop: "2px",
                                    display: "flex",
                                    gap: "5px",
                                    flexDirection: "row",
                                    alignItems: "center"
                                }}
                                fontSize={"14px"}><LocationOn style={{ fontSize: "15px" }} />{jobDetails.locationName ? jobDetails.locationName : "Location not available"}</Typography>

                            <Box sx={{ flexDirection: "row", gap: "10px", alignItems: "center", display: "flex", flexWrap: "wrap" }} >

                                <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "8px", marginTop: "10px", flexWrap: "wrap" }} >

                                    {
                                        [jobDetails.workType, jobDetails.experience, jobDetails.employmentType, `${jobDetails._id ? getSalary(jobDetails) : ""}`].map((item, index) => (
                                            <Typography color={index == 3 ? "#ff8800" : "#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    marginTop: "5px",
                                                    display: "-webkit-box",
                                                    background: index == 3 ? "#ff880010" : "#ffffff10",
                                                    paddingInline: "15px",
                                                    borderRadius: "4px",
                                                    minWidth: "20px",
                                                    paddingBlock: "5px",
                                                    alignSelf: "flex-start",
                                                    whiteSpace: "nowrap",
                                                    WebkitLineClamp: 1,      // change to 3,4 if needed
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden"
                                                }}
                                                fontSize={"13px"}>{item}</Typography>
                                        ))
                                    }

                                </Box>

                            </Box>

                            <Box sx={{ display: "flex", flex: 1 }} />

                            {
                                jobDetails._id && (
                                    <Typography onClick={async () => {
                                        try {
                                            await navigator.clipboard.writeText(jobDetails._id ? jobDetails._id : "");
                                            console.log("Copied to clipboard!");
                                            alert("Text copied to clipboard.")
                                        } catch (err) {
                                            console.error("Failed to copy:", err);
                                        }
                                    }} color={"#c3c3c3"}
                                        fontFamily={"poppins-reg"}
                                        fontSize={"14px"}
                                        style={{
                                            alignSelf: "flex-start",
                                            paddingBlock: "8px",
                                            cursor: "pointer",
                                            paddingInline: "12px",
                                            border: "1px solid #ffffff00",
                                            borderRadius: "6px",
                                            display: "flex",
                                            background: "#ffffff05",
                                            gap: "5px",
                                            alignItems: "center",
                                            flexDirection: "row",
                                            marginTop: "10px"
                                        }}
                                    >{jobDetails._id ?? ""}<ContentCopy style={{ fontSize: "15px" }} /></Typography>
                                )
                            }


                        </Box>


                        <Box sx={{ height: "1px", background: "#aaaaaa10", marginTop: "20px", marginBottom: "15px" }} />



                        <Box sx={{
                            flexDirection: (isMobileScreen || isTabScreen) ? "column" : "row", display: "flex", alignItems: (isMobileScreen || isTabScreen) ? "undefined" : "center",
                            gap: (isMobileScreen || isTabScreen) ? "0px" : "10px", marginTop: "5px", background: "#ffffff08",
                            borderRadius: "15px", marginBottom: "10px"
                        }} >

                            <Box sx={{
                                flexDirection: "row", display: "flex", alignItems: "center",
                                gap: "10px", flex: 1, paddingInline: "14px",
                                paddingBlock: "13px",
                            }} >

                                <CalendarMonthRounded style={{ fontSize: "30px" }} />

                                <Box sx={{ flex: 1, flexDirection: "column", display: "flex" }} >

                                    <Typography color={"#aaaaaa"}
                                        fontFamily={"poppins-reg"}
                                        style={{
                                            display: "flex",
                                            marginBottom: "2px",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                        fontSize={"12px"}>{"Posted on"}</Typography>


                                    <Typography color={"#ffffff"}
                                        fontFamily={"poppins-reg"}
                                        style={{
                                            display: "flex",
                                            marginTop: "-1px",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                        fontSize={"15px"}>{formatMongoTime(jobDetails.createdAt ? jobDetails.createdAt : new Date().toISOString(), "DD MMMM YYYY, HH:MM A")}</Typography>


                                </Box>


                            </Box>

                            <Box sx={{ width: (isMobileScreen || isTabScreen) ? "auto" : "1px", height: (isMobileScreen || isTabScreen) ? "1px" : "30px", background: "#aaaaaa10" }} />

                            <Box sx={{
                                flexDirection: "row", display: "flex", alignItems: "center",
                                gap: "10px", flex: 1, paddingInline: "14px",
                                paddingBlock: "13px"
                            }} >

                                <ClockIcon style={{ fontSize: "30px" }} />

                                <Box sx={{ flex: 1, flexDirection: "column", display: "flex" }} >

                                    <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "5px", marginBottom: "4px" }}>
                                        <Typography color={"#aaaaaa"}
                                            fontFamily={"poppins-reg"}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                marginTop: "2px"
                                            }}
                                            fontSize={"12px"}>{"Valid Till"}</Typography>

                                        {
                                            (!jobDetails.isActive || new Date(jobDetails.validTill).getTime() < Date.now()) && (
                                                <Typography color={"#ff8800"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        background: "#ff880010",
                                                        borderRadius: "100px",
                                                        paddingInline: "10px",
                                                        paddingBlock: "2px",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}
                                                    fontSize={"10px"}>{"Closed"}</Typography>
                                            )
                                        }



                                    </Box>


                                    <Typography color={"#ffffff"}
                                        fontFamily={"poppins-reg"}
                                        style={{
                                            display: "flex",
                                            marginTop: "-1px",
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                        fontSize={"15px"}>{formatMongoTime(jobDetails.validTill ? jobDetails.validTill : new Date().toISOString(), "DD MMMM YYYY, HH:MM A")}</Typography>


                                </Box>


                            </Box>
                        </Box>


                        {
                            jobDetails.priorityPass && (
                                <Box sx={{
                                    flexDirection: (isMobileScreen || isTabScreen) ? "column" : "row", display: "flex", alignItems: (isMobileScreen || isTabScreen) ? "undefined" : "center",
                                    gap: (isMobileScreen || isTabScreen) ? "0px" : "10px", background: "#ffffff08",
                                    borderRadius: "15px",
                                }} >

                                    <Box sx={{
                                        flexDirection: "row", display: "flex", alignItems: "center",
                                        gap: "10px", flex: 1, paddingInline: "14px",
                                        paddingBlock: "13px",
                                    }} >


                                        <Box sx={{ flex: 1, flexDirection: "column", display: "flex" }} >


                                            <Box sx={{
                                                flexDirection: "row", alignItems: "center", display: "flex", marginBottom: "2px",
                                                gap: "10px"
                                            }} >

                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}
                                                    fontSize={"14px"}>{"Priority Pass✨"}</Typography>



                                                <Typography color={(jobDetails.priorityPass?.enabled && new Date(jobDetails.priorityPass?.validity).getTime() > new Date().getTime()) ? "#00ff4c" : "#c1c1c1"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        background: (jobDetails.priorityPass?.enabled && new Date(jobDetails.priorityPass?.validity).getTime() > new Date().getTime()) ? "#00ff4c10" : "#ffffff10",
                                                        borderRadius: "100px",
                                                        paddingInline: "10px",
                                                        paddingBlock: "2px",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}
                                                    fontSize={"12px"}>{(jobDetails.priorityPass?.enabled && new Date(jobDetails.priorityPass?.validity).getTime() > new Date().getTime()) ? "Active" : "Expired"}</Typography>



                                            </Box>



                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    marginTop: "10px"
                                                }}
                                                fontSize={"12px"}>{"Purchased on"}</Typography>


                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    marginTop: "-1px",
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}
                                                fontSize={"15px"}>{formatMongoTime(jobDetails.priorityPass?.enabledAt ? jobDetails.priorityPass?.enabledAt : new Date().toISOString(), "DD MMMM YYYY, HH:MM A")}</Typography>



                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    marginTop: "10px"
                                                }}
                                                fontSize={"12px"}>{"Valid Till"}</Typography>


                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    marginTop: "-1px",
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}
                                                fontSize={"15px"}>{formatMongoTime(jobDetails.priorityPass?.validity ? jobDetails.priorityPass?.validity : new Date().toISOString(), "DD MMMM YYYY, HH:MM A")}</Typography>


                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    marginTop: "10px"
                                                }}
                                                fontSize={"12px"}>{"Contact Details"}</Typography>


                                            <Box sx={{
                                                flexDirection: "row", alignItems: "center", display: "flex", alignSelf: "stretch",
                                                paddingBlock: "15px",
                                                paddingInline: "15px",
                                                gap: "10px",
                                                flexWrap: "wrap",
                                                background: "#ffffff08",
                                                borderRadius: "10px",
                                                marginTop: "5px"
                                            }} >


                                                <Box sx={{ flexDirection: "column", display: "flex", minWidth: "30%" }} >

                                                    <Typography color={"#aaaaaa"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                        }}
                                                        fontSize={"12px"}>{"Name"}</Typography>

                                                    <Typography color={"#ffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            marginTop: "-1px",
                                                            flexDirection: "row",
                                                            alignItems: "center"
                                                        }}
                                                        fontSize={"15px"}>{jobDetails.priorityPass?.userContactDetails?.name ? jobDetails.priorityPass?.userContactDetails?.name : "..."}</Typography>

                                                </Box>


                                                <Box sx={{ flexDirection: "column", display: "flex", minWidth: "30%" }} >
                                                    <Typography color={"#aaaaaa"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                        }}
                                                        fontSize={"12px"}>{"Mobile Number"}</Typography>

                                                    <Typography color={"#ffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            marginTop: "-1px",
                                                            flexDirection: "row",
                                                            alignItems: "center"
                                                        }}
                                                        fontSize={"15px"}>{jobDetails.priorityPass?.userContactDetails?.mobileNo ? jobDetails.priorityPass?.userContactDetails?.mobileNo : "..."}</Typography>
                                                </Box>

                                                <Box sx={{ flexDirection: "column", display: "flex", minWidth: "30%" }} >

                                                    <Typography color={"#aaaaaa"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                        }}
                                                        fontSize={"12px"}>{"Email Address"}</Typography>

                                                    <Typography color={"#ffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            marginTop: "-1px",
                                                            flexDirection: "row",
                                                            alignItems: "center"
                                                        }}
                                                        fontSize={"15px"}>{jobDetails.priorityPass?.userContactDetails?.email ? jobDetails.priorityPass?.userContactDetails?.email : "..."}</Typography>


                                                </Box>



                                            </Box>




                                        </Box>


                                    </Box>


                                </Box>
                            )
                        }

                        {
                            jobDetails.boost && (
                                <Box sx={{
                                    flexDirection: (isMobileScreen || isTabScreen) ? "column" : "row", display: "flex", alignItems: (isMobileScreen || isTabScreen) ? "undefined" : "center",
                                    gap: (isMobileScreen || isTabScreen) ? "0px" : "10px", background: "#ffffff08",
                                    borderRadius: "15px", marginTop: "10px"
                                }} >

                                    <Box sx={{
                                        flexDirection: "row", display: "flex", alignItems: "center",
                                        gap: "10px", flex: 1, paddingInline: "14px",
                                        paddingBlock: "13px",
                                    }} >


                                        <Box sx={{ flex: 1, flexDirection: "column", display: "flex" }} >


                                            <Box sx={{
                                                flexDirection: "row", alignItems: "center", display: "flex", marginBottom: "2px",
                                                gap: "10px"
                                            }} >

                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}
                                                    fontSize={"14px"}>{"Boost Details 🚀"}</Typography>



                                                <Typography color={(jobDetails.boost?.isBoosted && new Date(jobDetails.boost?.validity).getTime() > new Date().getTime()) ? "#00ff4c" : "#c1c1c1"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        background: (jobDetails.boost?.isBoosted && new Date(jobDetails.boost?.validity).getTime() > new Date().getTime()) ? "#00ff4c10" : "#ffffff10",
                                                        borderRadius: "100px",
                                                        paddingInline: "10px",
                                                        paddingBlock: "2px",
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center"
                                                    }}
                                                    fontSize={"12px"}>{(jobDetails.boost?.isBoosted && new Date(jobDetails.boost?.validity).getTime() > new Date().getTime()) ? "Active" : "Expired"}</Typography>



                                            </Box>


                                            <Box sx={{
                                                flexDirection: "row", alignItems: "center", display: "flex", alignSelf: "stretch", flexWrap: "wrap",
                                                gap: "10px"
                                            }} >

                                                <Box sx={{ flexDirection: "column", minWidth: "40%", display: 'flex' }}>
                                                    <Typography color={"#aaaaaa"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            marginTop: "10px"
                                                        }}
                                                        fontSize={"12px"}>{"Purchased on"}</Typography>


                                                    <Typography color={"#ffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            marginTop: "-1px",
                                                            flexDirection: "row",
                                                            alignItems: "center"
                                                        }}
                                                        fontSize={"15px"}>{formatMongoTime(jobDetails.boost?.boostedAt ? jobDetails.boost?.boostedAt : new Date().toISOString(), "DD MMMM YYYY, HH:MM A")}</Typography>



                                                </Box>


                                                <Box sx={{ flexDirection: "column", minWidth: "40%", display: 'flex' }}>
                                                    <Typography color={"#aaaaaa"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            marginTop: "10px"
                                                        }}
                                                        fontSize={"12px"}>{"Valid Till"}</Typography>


                                                    <Typography color={"#ffffff"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            display: "flex",
                                                            marginTop: "-1px",
                                                            flexDirection: "row",
                                                            alignItems: "center"
                                                        }}
                                                        fontSize={"15px"}>{formatMongoTime(jobDetails.boost?.validity ? jobDetails.boost?.validity : new Date().toISOString(), "DD MMMM YYYY, HH:MM A")}</Typography>



                                                </Box>
                                            </Box>







                                        </Box>


                                    </Box>


                                </Box>
                            )
                        }


                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: "20px",
                                marginInline: "3px"
                            }}
                            fontSize={"14px"}>Job Link</Typography>
                        <Typography
                            onClick={async () => {
                                await navigator.clipboard.writeText(
                                    jobDetails.publicId
                                        ? `https://vybecerkle.com/c/job/${jobDetails.publicId}/share`
                                        : ""
                                );
                                alert("Copied!");
                            }}
                            color="#c3c3c3"
                            fontFamily="poppins-reg"
                            fontSize="14px"
                            sx={{
                                p: 2,
                                cursor: "pointer",
                                borderRadius: "15px",
                                background: "#000",
                                mt: 1,
                                display: "block",
                                wordBreak: "break-all",
                                overflowWrap: "anywhere"
                            }}
                        >
                            https://vybecerkle.com/c/job/{jobDetails.publicId}/share
                        </Typography>

                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: "15px"
                            }}
                            fontSize={"14px"}>Promotional Text</Typography>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                marginTop: "5px",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                            fontSize={"16px"}>{jobDetails.slogan ? jobDetails.slogan : "No promotional text"}</Typography>


                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: "15px"
                            }}
                            fontSize={"14px"}>About the Job</Typography>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                marginTop: "5px",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                            fontSize={"16px"}>{jobDetails.description ?? "Description not found"}</Typography>

                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: "15px"
                            }}
                            fontSize={"14px"}>Additional Requirements</Typography>

                        {
                            jobDetails.additionalInfo?.map((item, index) => (
                                <Box sx={{ flexDirection: "row", display: "flex", gap: "10px" }} >

                                    <Box sx={{ width: "5px", height: "5px", background: "#ffffff", borderRadius: "10px", marginTop: "10px" }} />
                                    <Typography color={"#ffffff"}
                                        fontFamily={"poppins-reg"}
                                        style={{
                                            display: "flex",
                                            flex: 1,
                                            flexDirection: "row",
                                            alignItems: "center"
                                        }}
                                        fontSize={"16px"}>{item}</Typography>
                                </Box>
                            ))
                        }





                        {/*  <Box sx={{
                                        display: 'flex', alignItems: 'center', alignSelf: 'stretch',
                                        position: "relative", flexDirection: "column", width: "300px", height: "300px"
                                    }}>
                                        <img
                                            alt="profile-user"
                                            width={"100%"}
                                            src={`${jobDetails.banner}`}
                                            style={{
                                                aspectRatio: 1 / 1,
                                                cursor: "pointer", objectFit: 'cover',
                                                borderRadius: "15px",
                                                border: "2px solid #ffffff05"
                                            }}
                                        />

                                        <Box sx={{ width: "100%", height: "100%", position: "absolute", background: "#00000010" }} />



                                    </Box> */}


                    </Box>
                    <Box

                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background: "#ffffff08",
                            flexDirection: "column",
                            padding: "20px",
                            position: "relative",
                            width: isMobileScreen ? "100%" : isTabScreen ? "90%" : "40%"
                        }}
                        display="flex"
                    >

                        <Box sx={{ flexDirection: isMobileScreen ? "column" : "row", alignItems: isMobileScreen ? "stretch" : "center", display: "flex", gap: "10px" }} >

                            <Box
                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #aaaaaa05",
                                }}
                                onClick={() => {
                                    navigate(`/admin/add-u-sa?ref=${jobDetails._id}`)
                                }}
                                display="flex"
                                flex={isMobileScreen ? undefined : 1}
                                py={"14px"}
                                alignItems={"center"}
                                justifyContent="center"
                            >
                                <Statbox
                                    // todayonboardusers
                                    title={totalApplicant ?? 0}
                                    subtitle="Total Applications"
                                    showIcon={false}
                                    titleTextSize="18px"
                                    subtitleTextSize="12px"
                                    onClick={() => {

                                    }}
                                    users={true}
                                />
                            </Box>

                            {/* <Box
                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #aaaaaa05",
                                }}
                                display="flex"
                                flex={isMobileScreen ? undefined : 1}
                                py={"14px"}
                                alignItems={"center"}
                                justifyContent="center"
                            >
                                <Statbox
                                    // todayonboardusers
                                    title={metrics.totalSoldTickets ?? 0}
                                    showIcon={false}
                                    titleTextSize="18px"
                                    subtitleTextSize="12px"
                                    subtitle="Tickets Sold"
                                    onClick={() => {

                                    }}
                                    users={true}
                                />
                            </Box> */}

                            {/* {
                                jobDetails.isPaid && (
                                    <Box
                                        sx={{
                                            background: "#ffffff08",
                                            borderRadius: "20px",
                                            border: "1.5px solid #aaaaaa05",
                                        }}
                                        display="flex"
                                        flex={isMobileScreen ? undefined : 1}
                                        py={"14px"}
                                        alignItems={"center"}
                                        justifyContent="center"
                                    >
                                        <Statbox
                                            // todayonboardusers
                                            title={`₹${(metrics.totalCollectedAmount ?? 0).toFixed(2)}`}
                                            subtitle="Amount Received"
                                            showIcon={false}
                                            titleTextSize="18px"
                                            subtitleTextSize="12px"
                                            onClick={() => {

                                            }}

                                            users={true}
                                        />
                                    </Box>
                                )
                            } */}

                        </Box>

                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginInline: "3px",
                                marginTop: "10px"
                            }}
                            fontSize={"14px"}>Applicants</Typography>

                        <Box sx={{
                            flexDirection: "column", display: "flex", minHeight: "500px", maxHeight: "600px",
                            overflow: "scroll", gap: "10px"
                        }} >
                            {
                                registrations.map((item, index) => (
                                    <Box
                                        onClick={() => {
                                            setSelectedApplication(item)
                                        }}
                                        sx={{
                                            flexDirection: "row", alignItems: "center", display: "flex",
                                            background: "#ffffff08",
                                            paddingInline: "15px",
                                            cursor: "pointer",
                                            paddingBlock: "10px",
                                            borderRadius: "15px",
                                            marginTop: index == 0 ? "10px" : "0px",
                                            gap: "10px"
                                        }} >

                                        <Box sx={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            flexShrink: 0,
                                        }}>
                                            <Avatar
                                                src={item.user.image[0] ?? ""}
                                                imgProps={{
                                                    referrerPolicy: "no-referrer",
                                                    decoding: "async",
                                                    style: {
                                                        width: `${40 * dpr}px`,
                                                        height: `${40 * dpr}px`,
                                                        transform: `scale(${1 / dpr})`,
                                                        transformOrigin: "top left",
                                                        imageRendering: "auto"
                                                    }
                                                }}
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    border: "2px solid #ffffff05",
                                                    bgcolor: "#111",
                                                }}
                                            />
                                        </Box>

                                        <Box sx={{
                                            flexDirection: "column",
                                            display: "flex",
                                            flex: 1
                                        }} >

                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                }}
                                                fontSize={"14px"}>{item.user.full_name}</Typography>
                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                }}
                                                fontSize={"12px"}>{item.user.buzz_name}</Typography>

                                        </Box>

                                        <Typography color={"#aaaaaa"}
                                            fontFamily={"poppins-reg"}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                alignSelf: "flex-start"
                                            }}
                                            fontSize={"12px"}>{formatMongoTime(item.createdAt ?? new Date().toISOString(), "DD MMM YYYY")}</Typography>

                                    </Box>
                                ))
                            }

                            {
                                hasEnded && (
                                    <Box sx={{
                                        marginTop: "20px", marginBottom: "30px", color: "#ffffff90", alignSelf: "center",
                                        fontFamily: "poppins-reg", fontSize: "12px"
                                    }} >- That's all for now -</Box>
                                )
                            }

                            {
                                !hasEnded && registrations.length > 0 && (
                                    <Box onClick={() => {
                                        if (!hasEnded) {
                                            getJobRegistrations(currentPage + 1)
                                        }
                                    }} sx={{
                                        alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                        fontFamily: "poppins-reg", fontSize: "13px", borderRadius: "10px", border: "1px solid #943bff",
                                        background: "#943bff20", cursor: "pointer",
                                    }} >Load More</Box>
                                )
                            }
                        </Box>





                    </Box>

                </Box>

                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>


                    <ApplicationDetailPopup
                        open={selectedApplication._id ? true : false}
                        onClose={() => setSelectedApplication({})}
                        data={selectedApplication}
                        questions={additinalQuestions}
                    />





                    {/* <Typography style={{ fontSize: "25px", fontFamily: "poppins-reg", color: "#f0f0f0", marginBottom: "20px" }} gutterBottom></Typography> */}




                </Box>

            </Box>
        </>
    );
}

export default JobDetailScreen;
